import React from "react";
import { Flex } from "antd";
import { Text } from "components/Text";
import { ButtonWrapper, StyledFlex, StyledButton } from "./style";
import { LinkBreak } from "assets/icons";
import { useNavigate } from "react-router";
import spacing from "theme/spacing.module.scss";

export const Error = ({ showBackToMainPageBtn = true }) => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  }
  const handleGoToMainPage = () => {
    navigate("/");
  }

  return (
    <StyledFlex vertical justify="space-between" align="center">
      <Flex vertical gap={spacing.spacingXL} align="center">
        <Flex vertical gap={spacing.spacingMD} align="center">
          <LinkBreak width={40} height={40}/>
          <Text $textVariant="h2">Błąd ładowania strony</Text>
        </Flex>
        <Text $textVariant="pSM">
          Przepraszamy, wystąpił problem podczas ładowania strony. Może to być spowodowane chwilowym problemem z serwerem.
        </Text>
      </Flex>
      <ButtonWrapper>
        <StyledButton type="primary" size="large" onClick={handleRefresh}>Odśwież stronę</StyledButton>
          {showBackToMainPageBtn && (
              <StyledButton type="text" size="large" onClick={handleGoToMainPage}>Wróć do strony głównej</StyledButton>
          )}
      </ButtonWrapper>
    </StyledFlex>
  );
}
